<template>
  <div class="origin-sub-title">
    <div class="author">{{ author }}</div>
    <div class="wechat">
      <span class="name">{{ weChatName }}</span>
      <div
        class="qrcode"
        v-if="accountType == '1'"
        @click="copyText(weChatName)"
      >
        <img :src="qrCode" alt="" />
        <div class="tips">
          <p>扫一扫/长按</p>
          <p>关注该公众号</p>
        </div>
      </div>
    </div>
    <div class="copy-tips" v-show="showTips">公众号已复制，搜索可关注</div>
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
import service from "../../services/article";
export default {
  name: "OriginSubtitle",
  data() {
    return {
      weChatName: "",
      qrCode: "",
      accountType: "2",
      showTips: false,
      author: ""
    };
  },
  created() {
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.author = info.author;
        this.getWechat(info);
      }
    });
  },
  methods: {
    getWechat(info) {
      const params = {
        weChatId: info.weChatId || 0,
        isAuthorize: 0
      };
      service.getWechat(params).subscribe(data => {
        this.weChatName = data.content.name;
        this.accountType = data.content.accountType;
        this.qrCode =
          data.content.accountType == "1"
            ? data.content.qrCodeUrl
            : require("../../assets/images/qrcode-tips.png");
      });
    },
    copyText(text) {
      if (this.accountType == 2) {
        this.copyToClipboard(text);
        this.showTips = true;
        setTimeout(() => {
          this.showTips = false;
        }, 1500);
      }
    },
    copyToClipboard(s) {
      if (window.clipboardData) {
        window.clipboardData.setData("text", s);
      } else {
        (function(s) {
          document.oncopy = function(e) {
            e.clipboardData.setData("text", s);
            e.preventDefault();
            document.oncopy = null;
          };
        })(s);
        document.execCommand("Copy");
      }
    }
  },
  components: {}
};
</script>
